import { IconProps } from "./types";

export default function MicrophoneIcon({ className }: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_682_1955)">
        <circle
          cx="15.0898"
          cy="8.30083"
          r="5.12439"
          transform="rotate(45 15.0898 8.30083)"
          stroke="currentColor"
          strokeWidth="1.48692"
        />
        <path
          d="M9.75488 8.49805L3.5174 16.1612C3.13234 16.6343 3.16752 17.322 3.59883 17.7533L5.81468 19.9691C6.2542 20.4087 6.95801 20.4357 7.42995 20.0312L14.892 13.6351"
          stroke="currentColor"
          strokeWidth="1.48692"
        />
        <line
          x1="11.6641"
          y1="5.00896"
          x2="18.5795"
          y2="11.9243"
          stroke="currentColor"
          strokeWidth="1.48692"
        />
        <line
          x1="2.70965"
          y1="21.2106"
          x2="5.2782"
          y2="18.6421"
          stroke="currentColor"
          strokeWidth="1.48692"
        />
      </g>
      <defs>
        <clipPath id="clip0_682_1955">
          <rect
            width="23.7907"
            height="23.7907"
            fill="currentColor"
            transform="translate(0.604736 0.212402)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
